<template>
    <div>
        <template v-if="type=='message'">
            <show-message v-model="message"></show-message>
        </template>
        <template v-if="type=='generic'">
            <generic-viewer v-model="generics" :size="size"></generic-viewer>
        </template>
        <template v-if="type=='json'">
            <show-message v-model="messages"></show-message>
        </template>

    </div>
</template>

<script>
import GenericViewer from '@/components/elements/GenericViewer'
import ShowMessage from '@/components/elements/MessageViewer'
    export default {
        name: 'getstarted-message',
        props: {
            'value': {
                default: [[]]
            },
            'size': {
                detault: 'big'
            }
        },
        data: function(){
            return {
                generics: [],
                message: '',
                type: '',
                messages: [[]]
            }
        },
        components: {
            GenericViewer,
            'show-message' : ShowMessage
        },
        created: function(){
            var vm = this
            vm.generics = this.value.generics
            
            var group = []
            var group_messages = this.value.message.split('||')  
            $.each(group_messages,function(index, messages){
                var messages = messages.split('#nl') 
                var newMessages = []   
                $.each(messages, function(inedx, message){
                    if (vm.isURL(message)) {
                        newMessages.push(
                            {
                                type: 'image',
                                image_url: message
                            }
                        )
                    } else if (!isNaN(message)) {
                        newMessages.push({
                            type: 'text',
                            text: message,
                        })
                    } else if(vm.isJsonParseable(message)) {
                        var parsedMessage = JSON.parse(message)
                        newMessages.push(
                            {
                                type: 'button',
                                text: parsedMessage.text,
                                buttons: parsedMessage.buttons
                            }
                        )
                    } else {
                        newMessages.push(
                            {
                                type: 'text',
                                text: message
                            }
                        )
                    }
                })
                group.push(newMessages)
            })
            
            vm.message = group

            this.messages = this.value.messages
            vm.type = this.value.type
        },
        methods: {
        },
        watch: {
            value: function(){
                this.generics = this.value.generics
                this.message = this.value.message
                this.messages = this.value.messages
                this.type = this.value.type
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/intent/IntentGetstarted.vue